import React from "react";
import Layout from "../components/layout";

const Settings = () => {
  return (
    <Layout>
    </Layout>
  );
};

export default Settings;
